import { CreateObraMateriaisControladosRequest } from "../../../data/daos/create/create_obra_materiais_controlados";
import { ICreateObraMateriaisControladosUseCase } from "../../../presentation/useCases/create/create_obra_materiais_controlados_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateObraMateriaisControladosUseCase
 */

export class CreateObraMateriaisControladosUseCase implements ICreateObraMateriaisControladosUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async createObraMateriaisControlados(model: CreateObraMateriaisControladosRequest): Promise<void> {
    await this.repository.postObraMateriaisControladosCreate(model);
  }
}
